export const setColor = (color) => {
    return{
        type: "setColor",
        payload: color
    }
}

export const setText = (text) => {
    return{
        type: "setText",
        payload: text,
    }
}

export const setFile = (file) => {
    return{
        type: "setFile",
        payload:file,
    }
}

export const nextStep = () => {
    return{
        type: "nextStep"
    }
}

export const setSetting = (opition) => {
    return{
        type:"setSetting",
        payload: opition,
    }
}

export const setZoom = (zoom) => {
    return{
        type: "setZoom",
        payload: zoom,
    }
}

export const setRotate = (rotate) => {
    return{
        type: "setRotate",
        payload: rotate,
    }
}

export const moveUp = () => {
    return{
        type:"moveUp"
    }
}

export const moveDown = () => {
    return{
        type:"moveDown"
    }
}

export const moveRight = () => {
    return{
        type:"moveRight"
    }
}

export const moveLeft = () => {
    return{
        type:"moveLeft"
    }
}

export const setFrame1 = () => {
    return{
        type:"setFrame1"
    }
}

export const setFrame2 = () => {
    return {
        type: "setFrame2"
    }
}

export const setFrame3 = () => {
    return {
        type: "setFrame3"
    }
}

export const setFrame4 = () => {
    return {
        type: "setFrame4"
    }
}

export const setFrame5 = () => {
    return {
        type: "setFrame5"
    }
}

export const setFrame6 = () => {
    return {
        type: "setFrame6"
    }
}

export const setDay1 = () => {
    return{
        type: "setDay1"
    }
}

export const setDay2 = () => {
    return {
      type: "setDay2"
    };
  };
  
  export const setDay3 = () => {
    return {
      type: "setDay3"
    };
  };
  
  export const setDay4 = () => {
    return {
      type: "setDay4"
    };
  };
  
  export const setDay5 = () => {
    return {
      type: "setDay5"
    };
  };
  
  export const setDay6 = () => {
    return {
      type: "setDay6"
    };
  };
  
  export const setDay7 = () => {
    return {
      type: "setDay7"
    };
  };
  
  export const setDay8 = () => {
    return {
      type: "setDay8"
    };
  };
  
  export const setDay9 = () => {
    return {
      type: "setDay9"
    };
  };
  
  export const setDay0 = () => {
    return {
      type: "setDay0"
    };
  };
  